import axiosServices from "../utils/axios";

export const fetchLocationGradesByLocation = async (locationId: string) => {
  const response = await axiosServices.get(`/location-grades`, {
    params: { location_id: locationId },
  });
  return response.data.data;
};

export const addLocationGradeApi = async (data: {
  location_id: string;
  grade_id: string;
}) => {
  const response = await axiosServices.post(`/location-grades`, data);
  return response.data.data;
};

export const removeLocationGradeApi = async (locationGradeId: string) => {
  const response = await axiosServices.delete(`/location-grades/${locationGradeId}`);
  return { success: response?.data?.success, id: locationGradeId };
};
